import getApi from '../../api'
import { Prescription } from '../../model/Prescription'

export const switchPrescriptionToVMP = (prescriptionId: string) =>
  getApi().put<Prescription>(`/prescriptions/${prescriptionId}/convert_to_vmp`)
